import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { FeatureFlagsProvider } from './contexts/FeatureFlagsContext.tsx'

// Normalize trailing slashes for SEO consistency
// Redirect paths with trailing slashes to non-trailing (except root)
const path = window.location.pathname;
if (path !== '/' && path.endsWith('/')) {
  const newPath = path.slice(0, -1);
  window.history.replaceState(null, '', newPath + window.location.search + window.location.hash);
}

createRoot(document.getElementById("root")!).render(
  <FeatureFlagsProvider>
    <App />
  </FeatureFlagsProvider>
);
